<div class="promotions-page">
  <section class="promotions-page__main">
    <h1 class="promotions-page__title">{{ 'promotions.forYou' | translate }}</h1>

    <app-tabs-v2
      [tabs]="statusTabs"
      [selectedTab]="selectedStatusTabId()"
      (selectedTabChange)="onStatusTabChange($event)"
    ></app-tabs-v2>

    @if (isPastTab()) {
      <section class="promotions-page__past-tools" [attr.aria-label]="'promotions.past.toolsLabel' | translate">
        <div class="promotions-page__past-controls">
          <label class="promotions-page__search">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M10.75 5.5a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5ZM4 10.75a6.75 6.75 0 1 1 12.08 4.14l3.52 3.51-1.06 1.06-3.51-3.52A6.75 6.75 0 0 1 4 10.75Z"
                fill="#393E44"
              />
            </svg>
            <input
              type="search"
              [formControl]="pastSearchControl"
              [placeholder]="'common.search' | translate"
              [attr.aria-label]="'common.search' | translate"
            />
          </label>

          <korviu-select
            class="list-actions-sort"
            [class.selected-option]="pastSortControl.value"
            [control]="pastSortControl"
            [options]="pastSelectOptions"
            [label]="('korviuList.sort' | translate) + (pastSortControl.value ? ' (1)' : '')"
            [prefixType]="'sort'"
            [customDropdown]="true"
          >
            <nz-radio-group [formControl]="pastSortControl">
              <nz-collapse nzGhost>
                <nz-collapse-panel [nzHeader]="'promotions.past.endDate' | translate" [nzActive]="true">
                  <label nz-radio [nzValue]="null">{{ 'promotions.past.defaultOrder' | translate }}</label>
                  <label nz-radio [nzValue]="pastSortNewestValue">
                    {{ 'promotions.past.newestToOldest' | translate }}
                  </label>
                  <label nz-radio [nzValue]="pastSortOldestValue">
                    {{ 'promotions.past.oldestToNewest' | translate }}
                  </label>
                </nz-collapse-panel>
              </nz-collapse>
            </nz-radio-group>
          </korviu-select>

          <korviu-select
            class="list-actions-filter"
            [class.selected-option]="pastResultControl.value"
            [control]="pastResultControl"
            [options]="pastSelectOptions"
            [label]="('korviuList.filter' | translate) + (pastResultControl.value ? ' (1)' : '')"
            [prefixType]="'filter'"
            [customDropdown]="true"
          >
            <nz-radio-group [formControl]="pastResultControl">
              <nz-collapse nzGhost>
                <nz-collapse-panel [nzHeader]="'promotions.past.result' | translate" [nzActive]="true">
                  <label nz-radio [nzValue]="null">{{ 'promotions.past.allResults' | translate }}</label>
                  <label nz-radio nzValue="won">{{ 'promotions.past.won' | translate }}</label>
                  <label nz-radio nzValue="lost">{{ 'promotions.past.lost' | translate }}</label>
                  <label nz-radio nzValue="pending_draw">{{ 'promotions.past.pendingDraw' | translate }}</label>
                  <label nz-radio nzValue="null">{{ 'promotions.past.notParticipated' | translate }}</label>
                </nz-collapse-panel>
              </nz-collapse>
            </nz-radio-group>
          </korviu-select>
        </div>

        <div class="promotions-page__past-counts">
          <span>{{ 'promotions.past.totalPromotions' | translate: { count: pageMeta().count } }}</span>
          <span>
            {{
              'promotions.past.showingPromotions'
                | translate
                  : {
                      start: pastVisibleRange().start,
                      end: pastVisibleRange().end,
                      count: pastVisibleRange().count
                    }
            }}
          </span>
        </div>
      </section>
    }

    @if (promotionsIsLoading()) {
      <div class="promotions-page__loader">
        <korviu-loader></korviu-loader>
      </div>
    } @else if (promotionsLoadError()) {
      <div class="promotions-page__error" role="alert">
        <p>{{ 'promotions.loadError' | translate }}</p>
        <button type="button" (click)="loadPromotions()">{{ 'promotions.retry' | translate }}</button>
      </div>
    } @else if (visiblePromotions().length) {
      <div
        class="promotions-page__cards"
        [class.promotions-page__cards--participating]="isParticipatingTab()"
        [class.promotions-page__cards--past]="isPastTab()"
      >
        @for (promotion of visiblePromotions(); track promotion.id) {
          <app-promotion-card [promotion]="promotion" [variant]="selectedStatus()"></app-promotion-card>
        }
      </div>

      @if (hasFeaturedCarousel()) {
        <nav class="promotions-page__controls" [attr.aria-label]="'promotions.featuredNavigation' | translate">
          <button
            type="button"
            class="promotions-page__control"
            [disabled]="!canGoToPreviousFeatured()"
            [attr.aria-label]="'promotions.previousFeatured' | translate"
            (click)="onFeaturedPageChange(featuredPage() - 1)"
          >
            <img src="assets/img/promotions/featured-previous.svg" width="32" height="32" alt="" />
          </button>
          <span class="promotions-page__featured-position" role="status" aria-live="polite">
            {{ 'promotions.featuredPosition' | translate: { current: featuredPosition(), total: pageMeta().count } }}
          </span>
          <button
            type="button"
            class="promotions-page__control"
            [disabled]="!canGoToNextFeatured()"
            [attr.aria-label]="'promotions.nextFeatured' | translate"
            (click)="onFeaturedPageChange(featuredPage() + 1)"
          >
            <img src="assets/img/promotions/featured-next.svg" width="32" height="32" alt="" />
          </button>
        </nav>
      } @else if (isParticipatingTab() || isPastTab()) {
        <div class="promotions-page__pagination">
          <button
            type="button"
            class="promotions-page__pagination-arrow"
            [disabled]="currentPage() === 1"
            (click)="onPastPageChange(currentPage() - 1)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M12.0833 5.41669L7.5 10L12.0833 14.5834"
                stroke="#AFB2B6"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button type="button" class="promotions-page__pagination-item promotions-page__pagination-item--active">
            {{ currentPage() }}
          </button>
          @if (pageMeta().totalPages > currentPage()) {
            <button
              type="button"
              class="promotions-page__pagination-item"
              (click)="onPastPageChange(currentPage() + 1)"
            >
              {{ currentPage() + 1 }}
            </button>
          }
          <button
            type="button"
            class="promotions-page__pagination-arrow"
            [disabled]="currentPage() === pageMeta().totalPages"
            (click)="onPastPageChange(currentPage() + 1)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M7.91669 5.41669L12.5 10L7.91669 14.5834"
                stroke="#505760"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      }
    } @else {
      <div class="promotions-page__empty">
        <korviu-no-data size="medium" [message]="'promotions.emptyPromotions' | translate"></korviu-no-data>
      </div>
    }
  </section>

  <aside class="promotions-page__aside">
    @if (summaryLoadError()) {
      <section class="promotions-page__error" role="alert" [attr.aria-label]="'promotions.summary.title' | translate">
        <p>{{ 'promotions.summary.loadError' | translate }}</p>
        <button type="button" (click)="loadSummary()">{{ 'promotions.retry' | translate }}</button>
      </section>
    } @else {
      <app-promotions-summary [summary]="summary()" [isLoading]="summaryIsLoading()"></app-promotions-summary>
    }

    @if (isBannerVisible()) {
      <section class="promotions-page__banner">
        <button
          class="promotions-page__banner-close"
          type="button"
          [attr.aria-label]="'promotions.closeBanner' | translate"
          (click)="closeBanner()"
        >
          <span aria-hidden="true">x</span>
        </button>
        <h2>{{ 'promotions.bannerTitle' | translate }}</h2>
        <p>{{ 'promotions.bannerDescription' | translate }}</p>
      </section>
    }

    <app-recent-promotion-winners
      [winners]="recentWinners()"
      [isLoading]="recentWinnersIsLoading()"
    ></app-recent-promotion-winners>
  </aside>
</div>
